/* Auto Generated */

export enum LicenceStatus {
	unassigned = 229380000,
	assigned = 229380001,
	deleted = 229380002,
}
